var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_531_433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_531_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94233 13.8461V16.8461C7.94233 17.1038 8.02854 17.3189 8.20098 17.4913C8.37341 17.6637 8.58847 17.75 8.84615 17.75H9.53845C9.79613 17.75 10.0112 17.6637 10.1836 17.4913C10.3561 17.3189 10.4423 17.1038 10.4423 16.8461V13.8461H10.5385C10.7346 13.7333 10.9343 13.6163 11.1375 13.4952C11.3407 13.374 11.4423 13.1897 11.4423 12.9423V11.3077C11.4423 10.8218 11.2721 10.4086 10.9317 10.0683C10.5913 9.72787 10.1782 9.55768 9.6923 9.55768H8.6923C8.2064 9.55768 7.79326 9.72787 7.45288 10.0683C7.11251 10.4086 6.94233 10.8218 6.94233 11.3077V12.9423C6.94233 13.1897 7.04392 13.374 7.24712 13.4952C7.45032 13.6163 7.65 13.7333 7.84615 13.8461H7.94233ZM9.1923 8.59613C9.51665 8.59613 9.79004 8.48491 10.0125 8.26248C10.2349 8.04004 10.3461 7.76665 10.3461 7.4423C10.3461 7.11793 10.2349 6.84453 10.0125 6.6221C9.79004 6.39967 9.51665 6.28845 9.1923 6.28845C8.86793 6.28845 8.59453 6.39967 8.3721 6.6221C8.14967 6.84453 8.03845 7.11793 8.03845 7.4423C8.03845 7.76665 8.14967 8.04004 8.3721 8.26248C8.59453 8.48491 8.86793 8.59613 9.1923 8.59613ZM14.5442 10.75H17.2634C17.4185 10.75 17.5307 10.6849 17.6 10.5548C17.6692 10.4246 17.6666 10.2955 17.5922 10.1673L16.223 7.9827C16.1487 7.85448 16.0423 7.79038 15.9038 7.79038C15.7654 7.79038 15.659 7.85448 15.5846 7.9827L14.2154 10.1673C14.141 10.2955 14.1385 10.4246 14.2077 10.5548C14.2769 10.6849 14.3891 10.75 14.5442 10.75ZM16.223 16.0173L17.5922 13.8327C17.6666 13.7045 17.6692 13.5753 17.6 13.4452C17.5307 13.3151 17.4185 13.25 17.2634 13.25H14.5442C14.3891 13.25 14.2769 13.3151 14.2077 13.4452C14.1385 13.5753 14.141 13.7045 14.2154 13.8327L15.5846 16.0173C15.659 16.1455 15.7654 16.2096 15.9038 16.2096C16.0423 16.2096 16.1487 16.1455 16.223 16.0173ZM5.8077 20.5C5.30257 20.5 4.875 20.325 4.525 19.975C4.175 19.625 4 19.1974 4 18.6923V5.3077C4 4.80257 4.175 4.375 4.525 4.025C4.875 3.675 5.30257 3.5 5.8077 3.5H19.1923C19.6974 3.5 20.125 3.675 20.475 4.025C20.825 4.375 21 4.80257 21 5.3077V18.6923C21 19.1974 20.825 19.625 20.475 19.975C20.125 20.325 19.6974 20.5 19.1923 20.5H5.8077ZM5.8077 19H19.1923C19.282 19 19.3557 18.9711 19.4134 18.9134C19.4711 18.8557 19.5 18.782 19.5 18.6923V5.3077C19.5 5.21795 19.4711 5.14423 19.4134 5.08653C19.3557 5.02883 19.282 4.99998 19.1923 4.99998H5.8077C5.71795 4.99998 5.64423 5.02883 5.58653 5.08653C5.52883 5.14423 5.49997 5.21795 5.49997 5.3077V18.6923C5.49997 18.782 5.52883 18.8557 5.58653 18.9134C5.64423 18.9711 5.71795 19 5.8077 19Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorIcon);
export default __webpack_public_path__ + "static/media/ElevatorIcon.704bb1c38f673e2b65a78a69f2f0bb67.svg";
export { ForwardRef as ReactComponent };